<script>
  import { _ } from "svelte-i18n";

  export let query_vars = {
    posts_per_page: 12,
    paged: 1,
    orderby: menu_order,
  };
  export let total_matches = 0;
  export let products = null;
  export let description = "";

  export let changeSortOrder = (ev) => {};
</script>

<div class="a3_list_header">
  <!-- <header class="woocommerce-products-header">
    {description}
  </header> -->
  <div class="woocommerce-notices-wrapper" />
  <div class="freshio-sorting">
    <!--<button class="filter-toggle" aria-expanded="false">
            <i class="freshio-icon-filter"></i><span>{$_('category.Filter')}</span>
        </button>
        <button class="filter-toggle-dropdown" aria-expanded="false">
            <i class="freshio-icon-filter"></i><span>{$_('category.Filter')}</span>
        </button>-->
    <p class="woocommerce-result-count">
      {$_("category.Showing")}
      {products?.length == 0
        ? 0
        : query_vars.posts_per_page *
            (query_vars.paged === 0 ? 0 : query_vars.paged - 1) +
          1} – {products?.length < 1
        ? 0
        : Math.min(
            query_vars.posts_per_page *
              (query_vars.paged === 0 ? 1 : query_vars.paged),
            total_matches
          )} od {products?.length < 1 ? 0 : total_matches}
      {$_("category.results")}
    </p>
    <!-- <div class="gridlist-toggle desktop-hide-down">
            <a href="/trgovina/?layout=grid" id="grid" class="active" title="{$_('category.Grid View')}"><i
                    class="freshio-icon-th-large"></i></a>
            <a href="/trgovina/?layout=list" id="list" class="" title="{$_('category.List View')}"><i
                    class="freshio-icon-th-list"></i></a>
        </div> -->
    <form class="woocommerce-ordering" method="get">
      <select
        name="orderby"
        class="orderby"
        aria-label="Narudžba"
        bind:value={query_vars.orderby}
        on:change={changeSortOrder}
      >
        <option value="menu_order">{$_("category.Default sorting")}</option>
        <option value="popularity">{$_("category.Sort by popularity")}</option>
        <option value="rating">{$_("category.Sort by average rating")}</option>
        <option value="date">{$_("category.Sort by latest")}</option>
        <option value="price"
          >{$_("category.Sort by price: low to high")}</option
        >
        <option value="price-desc"
          >{$_("category.Sort by price: high to low")}</option
        >
      </select>
      <input type="hidden" name="paged" value="1" />
    </form>
  </div>
</div>

<style>
  .a3_list_header {
    padding: 10px;
  }
</style>
